import {useContext, useState} from 'react'
import {CustomerReportContext} from '../../context'
import moment from 'moment'
import Import from '../../../../images/Import.png'
import {SampleCSVDownload} from '../../../../components/SampleCSVDownload'
import {dataToCustomerTypeShippingCSV} from '../../utils'

const CustomerTypeReportsHeader = () => {
  const {customerTypeData} = useContext(CustomerReportContext)
  const [isLoading, setIsLoading] = useState(false)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)
    const formattedDateTime = moment().format('D_MMM_HH_mm').toLowerCase()
    const data = dataToCustomerTypeShippingCSV(customerTypeData)
    if (data?.length) {
      SampleCSVDownload(data || [], `Discount_Report_Customer_Type_Report_${formattedDateTime}`)
    }
    setIsLoading(false)
  }

  return (
    <div className='d-flex flex-wrap justify-content-between align-items-center mb-10'>
      <h2 className='text-dark fw-bolder mb-8'>Customer Type</h2>
      <button
        className='btn btn-outline'
        onClick={handleDownLoadCSV}
        disabled={isLoading || !customerTypeData?.length}
      >
        <div className='d-flex align-items-center'>
          <img src={Import} alt='Import File' className='me-2 import-icon' />
          <div className='d-flex align-items-center'>
            {isLoading ? 'Downloading...' : 'Export CSV'}
            {isLoading && (
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            )}
          </div>
        </div>
      </button>
    </div>
  )
}
export default CustomerTypeReportsHeader
